import { quintOut } from "svelte/easing";
const defaultDuration = 2000;
const defaultFormatter = value => value;
export function roller(node, { value, duration = defaultDuration, formatter = defaultFormatter }) {
    let from = 0;
    let startTime;
    let range;
    let req;
    const cancel = () => cancelAnimationFrame(req);
    const setValue = val => node.innerText = formatter(val);
    function update() {
        const t = (performance.now() - startTime) / duration;
        setValue(from + Math.floor(quintOut(t) * range));
        if (t < 1)
            req = requestAnimationFrame(update);
        else
            setValue(value);
    }
    // No animation on creation
    value != null && setValue(value);
    return {
        destroy: cancel,
        update({ value: newValue, duration: newDuration = defaultDuration, formatter = defaultFormatter }) {
            cancel();
            if (newValue == null) {
                node.innerText = '';
                return;
            }
            startTime = performance.now();
            from = value || 0;
            range = newValue - from > 0 ? newValue - from : 0;
            value = newValue;
            duration = newDuration;
            if (range > 0)
                update();
            else
                setValue(value);
        }
    };
}
